import axios from "../utils/axios-interceptor";

export const registerUserApi = async(payload) => {
  try {
    const res = await axios.post("/register", payload);
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(`Error registering user: ${error.message}`);
  }
}


/* export const registerUserApi = async(payload) => {
  try {
    // Mocking the API call with a delay
    await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulate a delay

    // Dummy response data
    const dummyResponse = {
      message: "Registration successful!",
      user: {
        id: "123456",
        fullname: payload.fullname,
        email: payload.email,
      },
    };

    // Simulate successful response
    return dummyResponse;

    // Uncomment these lines to use a real API call
    // const res = await axios.post("/register", payload);
    // return res.data;
  } catch (error) {
    throw new Error(`Error registering user: ${error.message}`);
  }
}; */
